
import {Howl, Howler} from 'howler';

export default class WebAudioManager {

  constructor() {}

  loadAndPlay(path) {
    if (this.muted)
      return;

    if (this.isPlayingSource == true && this.path == path) {
      console.log("no replay");
      return;
    }

    this.path = path;

    this.sound = new Howl({
      src : [ path ],
      html5 : true,
      onend : function() {
        console.log('Finished!');
        this.isPlayingSource = false;
      }.bind(this)
    });

    this.sound.play();
    this.isPlayingSource = true;
  }

  pause() {
    if (this.sound != null)
      this.sound.pause();
    this.wasPlayingBefore = this.isPlayingSource;
    this.isPlayingSource = false;
  }

  unpause() {
    if (this.sound != null) {
      this.sound.play();
      this.isPlayingSource = true;
    }
  }

  mute() {
    this.muted = true;
    this.pause();
  }

  unmute() {
    this.muted = false;
    if (this.wasPlayingBefore) {
      if (this.sound != null) {
        this.sound.play();
        this.isPlayingSource = true;
      }
    }
  }
};
